import { render, staticRenderFns } from "./ConsentPage.vue?vue&type=template&id=6d6538be&scoped=true&"
import script from "./ConsentPage.vue?vue&type=script&lang=js&"
export * from "./ConsentPage.vue?vue&type=script&lang=js&"
import style0 from "./ConsentPage.vue?vue&type=style&index=0&id=6d6538be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6538be",
  null
  
)

component.options.__file = "ConsentPage.vue"
export default component.exports